







































































import { Component, Vue } from 'vue-property-decorator';
import { periodYears } from '@/app/paycheck-period';

@Component({
  components: {},
})
export default class PaycheckReportsList extends Vue {
  private years: number[] = [];
  private year = this.$dayjs().year();

  async created() {
    this.years = await periodYears();
    const missingCurrent = this.years.includes(this.year);
    if (!missingCurrent) {
      this.years = this.years.concat(this.year);
    }
  }
}
